<template>
  <div>
    <span v-if="dataValue.value < 0" class="negative">{{
      dataValue.text
    }}</span>
    <span v-else>{{ dataValue.text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    dataValue: {
      type: Object,
    },
    format: {
      type: String,
    },
  },
  components: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.negative {
  color: red;
}
</style>
